import { Flex } from '@chakra-ui/layout';
import React from 'react';
import { CircularProgress, Heading } from "@chakra-ui/react";

type ResourceProgressProps = {
  isLoading: boolean,
  isEmpty: boolean,
  emptyMessage?: string,
  padding?: number
};

const ResourceProgress: React.FC<ResourceProgressProps> = ({
  isLoading,
  isEmpty,
  emptyMessage,
  padding = 32
}) => {
  if (!isLoading && !isEmpty) {
    return (null);
  }

  return (
    <Flex
      justifyContent="center"
      pt={padding}
      pb={padding}
    >
      {
        isLoading ? (
          <CircularProgress isIndeterminate />
        ) : (
          isEmpty && emptyMessage && <Heading size="xs">{emptyMessage}</Heading>
        )
      }
    </Flex>
  );
}

export default React.memo(ResourceProgress);
